import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import { Dashboard } from "./Components/AdminPannel/Dashboard/Dashboard";
import LoginPage from "./Components/AdminPannel/Login/LoginPage";
import { VisitorRegistration } from "./Components/AdminPannel/Registration/VisitorRegistration";
import AbuDhabiPage from "./Pages/AbuDhabi";
import KenyaPage from "./Pages/KenyaLanding";
import Thailand from "./Pages/Thailand";
import SingaporePage from "./Pages/Singapore";
// import VisitorRegistration from "./Pages/VisitorRegistration";
import { BookingRegistration } from "./Components/AdminPannel/Registration/BookingRegistration";
import BookYourStall from "./Pages/BookYourStall";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage";
import VisitorRegistrationPage from "./Pages/VisitorRegistration";
import { PrivateRoute } from "./PrivateRoute";

// TOI Visitor Registration Form
import TOIVisitorRegistrationForm from "./Components/TOIForms/VisitorRegistrationFormTOI";
import BahrainFormRegistraion from "./Components/BahrainForm/BahrainFormRegistraion";
import Bahrain from "./Pages/Bahrain";
// IPE Visitor Registration Form
import IPEVisitorRegistrationForm from "./Components/IPEForm/VisitorRegistrationFormIPE";
import IPFRegistrationForm from "./Components/IPFRegistration/IPFRegistrationForm";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ThankyouPage from "./Pages/Thankyou/ThankyouPage";
import DubaiLanding from "./Pages/DubaiLanding";
import PrivacyPolicyDubai from "./Pages/PrivacyPolicyDubai";
import VisitorRegistrationFormDubai from "./Components/DubaiForm/DubaiForm";
import ThankyouPageDubai from "./Pages/Thankyou/ThankyouPageDubai";
import ErrorPage from "./Pages/ErrorPage";
import VisitorRegistrationFormSakal from "./Components/SakalGlobalRealityExpo/SakalVisitorRegistration";
import LodhaLandingPage from "./Components/LodhaLandingPage/LodhaLandingPage";
import ThankyouPageLodha from "./Pages/Thankyou/ThankyouPageLodha";
import { VisitorLeadsList } from "./Components/AdminPannel/LeadsUpdate/VisitorLeadsList";
import ThankyouPageBahrain from "./Pages/Thankyou/ThankyouPageBahrain";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        {/* <Route exact path="/" component={Home} /> */}
        <Route exact path="/" component={KenyaPage} />
        {/* <Route exact path="/" component={ErrorPage} /> */}
        <Route exact path="/singapore" component={SingaporePage} />
        <Route exact path="/jakarta" component={AbuDhabiPage} />
        <Route exact path="/belgium" component={KenyaPage} />
        <Route exact path="/lodha" component={LodhaLandingPage} />
        <Route exact path="/thailand" component={Thailand} />
        <Route
          exact
          path="/visitor-registration"
          component={VisitorRegistrationPage}
        />
        <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
        <Route exact path="/book-your-stall" component={BookYourStall} />
        <Route exact path="/admin" component={LoginPage} />
        <Route exact path="/dashboard">
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        </Route>
        <Route exact path="/visitor-registration-list">
          <PrivateRoute>
            <VisitorRegistration />
          </PrivateRoute>
        </Route>
        <Route exact path="/visitors-leads-list">
          <PrivateRoute>
            <VisitorLeadsList />
          </PrivateRoute>
        </Route>
        <Route exact path="/booking-enquiry">
          <PrivateRoute>
            <BookingRegistration />
          </PrivateRoute>
        </Route>

        {/* TOl Form */}
        <Route
          exact
          path="/visitorregistration"
          component={TOIVisitorRegistrationForm}
        />
        {/* Bahrain Form */}
        <Route
          exact
          path="/bahrainvisitorregistration"
          component={BahrainFormRegistraion}
        />
        {/* IPE Form */}
        <Route
          exact
          path="/visitorregistrationipe"
          component={IPEVisitorRegistrationForm}
        />
        {/* Dubai Form */}
        <Route
          exact
          path="/visitorregistrationdubai"
          component={VisitorRegistrationFormDubai}
        />
        {/* IPF Form */}
        <Route
          exact
          path="/visitorregistrationipf"
          component={IPFRegistrationForm}
        />
        <Route
          exact
          path="/visitorregistrationsakal"
          component={VisitorRegistrationFormSakal}
        />
        <Route exact path="/bahrain" component={Bahrain} />
        <Route exact path="/bahrain-thankyou" component={ThankyouPageBahrain} />
        <Route
          exact
          // path="/privacy-policy-hong-kong"
          path="/privacy-policy"
          component={PrivacyPolicy}
        />
        <Route
          exact
          path="/privacy-policy-dubai"
          component={PrivacyPolicyDubai}
        />
        <Route exact path="/thankyou" component={ThankyouPage} />
        <Route exact path="/lodha-thankyou" component={ThankyouPageLodha} />
        <Route exact path="/thankyoudubai" component={ThankyouPageDubai} />
        <Route exact path="/dubai" component={DubaiLanding} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
